export enum ClickTypeEnum {
	BUTTON = 'button',
	IMAGE = 'image',
	LINK = 'link',
}
